import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <circle key='0' fill='#FFFFFF' className='st0' cx='12' cy='12' r='11' />,
    <path
      key='1'
      d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z'
    />,
  ],
  'InspectionStatusFinished'
);

const InspectionStatusFinishedIcon = function (props) {
  return <SvgIcon {...props} />;
};

export default memo(InspectionStatusFinishedIcon);
